// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mOBm","newExpiryDate":"styles_newExpiryDate__3oPYE","footer":"styles_footer__3TsHV"};